import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactToPrint from "react-to-print";

import { Grid } from '@material-ui/core'
import Paper from '@material-ui/core/Paper'
import Modal from '@material-ui/core/Modal'
import html2canvas from 'html2canvas';


export class SchedulerImagePreview extends Component {
    constructor(props){
        super(props);

        this.state = {
            enablePrintBtn: false,
            newCanvas: undefined,
        }
    }

    printScheduler = async () =>{
        try{
            setTimeout(() => {
                const element = document.getElementById('printingBtn');
                
                if(!element) return undefined;
                element.click();

            }, 100);
            return undefined;
            
        }catch(err){
            return undefined
        }
    }

    removePrintingIframe = () =>{
        try{
            const element = document.getElementById('printWindow');

            if(!element) return undefined;

            element.remove();
        }catch(err){

        }
    }

    closePreviewModal = () =>{
        try{
            if(this.props.onCloseModal){
                this.props.onCloseModal()            
            }

        }catch(err){}
    }

    HeaderComponent = () =>{
        return(
            <Grid item container style={{height:'100%',}}>
                <Grid item container xs={6} justify='flex-start' alignContent='center' className='previewModalTitle'>
                    <Grid item>
                        Print Preview
                    </Grid>
                </Grid>
                <Grid item container xs={5} justify='flex-end' alignContent='center' style={{padding:'0px 10px'}}>
                    <Grid item >
                        
                                <Grid item 
                                    id='PrintScheduleBtn'
                                    style={{width:'200px', maxHeight:'70px', overflow:'hidden'}}
                                    className={(this.props.schedulerImage && this.state.enablePrintBtn)? "blueBottomButon appbtnBarButton" : "disableBottomButon appbtnBarButton"}
                                    disabled={!(this.props.schedulerImage && this.state.enablePrintBtn)}
                                    onClick={this.printScheduler}
                                >
                                    Print
                                </Grid> 
                                <ReactToPrint
                                    trigger={() => (<Grid id='printingBtn' style={{display:'none'}}></Grid>)}
                                    content={() => this.componentRef}
                                    onAfterPrint={() => this.closePreviewModal()}
                                /> 
                        
                    </Grid>
                </Grid>
                <Grid item container xs={1} justify='center' alignContent='center' style={{padding:'0px 10px'}}>
                    <Grid item style={{fontSize:'35px', cursor:'pointer'}} onClick={() => this.props.onCloseModal ? this.props.onCloseModal() : undefined}>
                        X
                    </Grid>
                </Grid>
            </Grid>
        )
    }

    resizePreviewImage= async () =>{
        const element = document.getElementById('provitionalImageContainer');
        if(!element) return undefined;

        const firstChild = element.firstChild;

        let height =undefined;
        let width = undefined;
        if(firstChild){
            const canvasStyleAtt = firstChild.getAttribute('style')
            const arrayWidthAndHeight =  (canvasStyleAtt && canvasStyleAtt.length > 0)? canvasStyleAtt.split(';'): undefined;
            if(arrayWidthAndHeight && arrayWidthAndHeight.length > 2){

                let pWidth = undefined;
                let pHeight = undefined;

                for(let i =0; i< 2; i++){
                    const current = arrayWidthAndHeight[i].toLowerCase().trim();

                    if(current.startsWith('width')){
                        const arrayW = current.split(':')

                        if(arrayW && arrayW.length=== 2){
                            pWidth = arrayW[1].trim(';').trim();
                        }
                    }else if(current.startsWith('height')){
                        const arrayH = current.split(':')

                        if(arrayH && arrayH.length=== 2){
                            pHeight = arrayH[1].trim(';').trim();
                        }
                    }
                }

                if(pWidth && pHeight){
                    pWidth = parseInt(pWidth.trim('px'));
                    pHeight = parseInt(pHeight.trim('px'));
                }

                if(Number.isInteger(pWidth) && Number.isInteger(pHeight)){
                    height = pHeight;
                    width = pWidth;
                }
            }

            const scale = .87
            if(height && width){
                height = height * scale;
                width = width * scale;
            }            

        firstChild.style=`width:${width}px; height: ${height}px;`

        }
        

        return 'finish'
    }

    getNewCanvas = async ()=> {
        try{
            const previewElement = document.getElementById('fullSizeScheduler');
            let newCanvas = undefined;

            if(!previewElement) return undefined;
            
            newCanvas = await html2canvas(previewElement, {logging: false, allowTaint: true,useCORS: true});
            
            // const img = document.getElementById('idImage');
            // img.width='300px'
            // img.height='300px'
            // img.src = newCanvas.toDataURL("image/png")
            // console.log('newCanvas', newCanvas)
            // console.log('newCanvas.toDataURL', )
             return newCanvas;
        }catch(err){}
    }

    placeNewCanvas = async(newCanvas) =>{
        const container = document.getElementById('provitionalImageContainer');

        if(!container  || !newCanvas) return undefined;
        
        container.replaceChildren(newCanvas);
    }

    ContentComponent = () => {
        setTimeout(() => {
            const element = document.getElementById('provitionalImageContainer');

            if(element && this.props.schedulerImage && !this.state.enablePrintBtn){
                element.appendChild(this.props.schedulerImage)

                setTimeout( async() => {
                    await this.resizePreviewImage();
                    const newCanvas = await this.getNewCanvas();
                    if(newCanvas){
                        await this.placeNewCanvas(newCanvas)
                        this.setState({enablePrintBtn: true,});        
                    }
                }, 100);
            }
        }, 200);

        
        const dynamicSchedulerClass = (this.props.schedulerType && this.props.schedulerType.toLowerCase() === 'daily')? 'schedulerSizePortrait': 'schedulerSize'
        return (
        <Grid item container>
            <Grid item container justify='center' style={{backgroundColor:'white' , overflow:'hidden'}}>
                <Grid item container id='fullSizeScheduler' className={dynamicSchedulerClass} justify='center' alignContent='flex-strat' style={{ zIndex:  this.state.enablePrintBtn? '3':'-3',}}>
                    <Grid item id='provitionalImageContainer'  ref={el => (this.componentRef = el)} ></Grid>
                </Grid>
            </Grid> 
        </Grid>
        )
    }
    render(){


        return(
            <Grid item container>
                <Modal
                    open={true}
                    onClose={() => this.props.onCloseModal ? this.props.onCloseModal() : undefined}
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                >
                    <Paper elevation={3} className="paperModalImagePreview EngageModal" color='secondary'>
                        <Grid item container style={{ padding: '10px 0px', height: '100%', overflow:'auto'}}>
                            {
                                (this.props.schedulerImage && this.props.schedulerImage instanceof HTMLElement)?
                                <Grid item container>
                                    <Grid item container style={{height:'10%'}}>
                                        <this.HeaderComponent/>
                                    </Grid>
                                    <Grid item container style={{height:'90%'}}>
                                        <this.ContentComponent/>
                                    </Grid>                                    
                                </Grid>
                                :
                                undefined  
                            }
                            </Grid>
                    </Paper>
                </Modal>
            </Grid>
        )
    }
}

function mapStateToProps(state) {
    return{

    }
};

export default connect(mapStateToProps, { })(SchedulerImagePreview)

